// src/pages/admin/services/programService.js
import {
  collection,
  getDocs,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  query,
  orderBy
} from 'firebase/firestore';
import { db } from '../../../firebase';

/**
 * Fetch all programs ordered by title.
 */
export const fetchPrograms = async () => {
  const snapshot = await getDocs(
    query(collection(db, 'programs'), orderBy('title', 'asc'))
  );
  return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
};

/**
 * Save a program. Creates if no programId, updates if programId provided.
 * @returns {Promise<string>} the saved program's id
 */
export const saveProgram = async (programData, programId = null) => {
  if (programId) {
    await updateDoc(doc(db, 'programs', programId), {
      ...programData,
      updatedAt: serverTimestamp()
    });
    return programId;
  } else {
    const ref = await addDoc(collection(db, 'programs'), {
      ...programData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    return ref.id;
  }
};

/**
 * Delete a program document.
 * Note: does not delete its assignments — handle separately if needed.
 */
export const deleteProgram = async (programId) => {
  await deleteDoc(doc(db, 'programs', programId));
};